<img class="img" src="../../../../assets/images/simbolos/checkedForm.svg">
<ng-container *ngIf="environment.company === 'km-do-brasil'; else mensagemApn">
  <p class="titulo">Seu pedido está em análise. Pedimos que não repita a solicitação!</p>
  <ng-container *ngIf="autorizacoes.listarHistoricosPedidos">
    <p class="texto">Logo você poderá visualizá-lo em</p>
    <a class="link" routerLink="/suprimentos/historico-de-pedidos">histórico de
      pedidos</a>
  </ng-container>
</ng-container>
<app-botao-submit class="botao" routerLink="/dashboard">Voltar ao dashboard</app-botao-submit>
<ng-template #mensagemApn>
  <p class="titulo">Seu pedido "{{codigoSuprimento}}" foi registrado com sucesso!</p>
  <p class="texto" *ngIf="autorizacoes.listarHistoricosPedidos">Você pode acompanhar o status do seu atendimento em</p>
  <a class="link" *ngIf="autorizacoes.listarHistoricosPedidos"
    [routerLink]="['/suprimentos/historico-de-pedidos', codigoSuprimento]">histórico de
    pedidos</a>
</ng-template>